<div class="dialog-container">
    <app-verify *ngIf="showVerify" [confirmMessage]="confirmMessage" [hideButton]="buttonStatus"
        [disableEdit] = "disableEdit"
        [buttonText]="verifyButtonText" [type]="type" (clicked)="verifyClick($event)"></app-verify>
    <app-publish *ngIf="showPublish" [status]="batchStatus" (clicked)="publish($event)"></app-publish>
    <app-success *ngIf="showSuccess" (clicked)="success($event)"></app-success>

</div>
